import { useUniqueClientComponentData } from "./data";
import { UniqueClientComponentUI } from "./ui";

const UniqueClientComponent = () => {
  const { currentStep } = useUniqueClientComponentData();
  return <UniqueClientComponentUI currentStep={currentStep} />;
};

export { UniqueClientComponent };
